// @External Dependencies
import axios from 'axios'

// @Dependencies
import { apiURL } from '../../../../Config/constants'
import { axiosError, getToken } from '../../../Services'

/**
 * @typedef {Object} FilterType
 * @property {string} [search] - Filtra por nombre de Curso o Diploma
 * @property {number} [year] - Filtra por Año los cursos
 * @property {number} campusId - Campus de los Cursos
 * @property {number} programId - Programa de los Cursos
 * @property {number} [page] - Limita los cursos por página
 * @property {number} [limit] - Cantidad de Cursos totales
 */
/**
 * @typedef {Object} InputType
 * @property {string} [type] - PAST | PRESENT | FUTURE | PRESENT_FUTURE
 * @property {FilterType} filters - Filtros de los cursos
 */

/**
 * Lista los cursos de una persona según los filtros
 *
 * Ocupamos esta query para Dashboard de Cursos y Registro Académico
 *
 * @param {InputType} input
 * @example
 * ```js
 *    const input = {
 *      type: 'PAST'
 *    }
 *    const students = await this.props.getCourseList(input)
 * ```
 * @returns {Promise<import('@eclass/api').CourseListPayload>}
 */
const getCourseList = (input: any) => {
  const requestId = 'getCourseList'
  return async (dispatch: any) => {
    getToken()
    const query = `
      query getCourseList($CourseListInput: CourseListInput!) {
        getCourseList(input: $CourseListInput) {
          status {
            success
            detail
          }
          hasSence
          hasAcademicHistory
          Programs {
            id
            name
            slug
            url
          }
          AcademicBlock {
            id
            name
            isSence
            href
            diploma
            activeUnit
            certified
            dates {
              start
              end
              deactivation
              completed
              days
            }
            status {
              id
              name
              detail
              style
            }
            qualification {
              value
              valueFormatted
              status {
                id
                name
                detail
                style
              }
            }
            studentProgress {
              resources
              progress
            }
            Profile {
              id
              name
            }
          }
        }
      }
    `

    const variables = {
      CourseListInput: {
        type: input.type || 'PRESENT_FUTURE',
        scheme: 2,
        filter: {
          ...input.filters,
          /**
           * Lógica de Campus y Programa se omite
           * hasta tener definido el Branding y Agrupación de Cursos
           */
          campusId: 0,
          programId: 0,
          limit: 999
        }
      }
    }

    /**
     * Si viene el Programa entonces filtramos los cursos
     */
    const programId = parseInt(input.programId, 10)
    if (programId) {
      variables.CourseListInput.filter.programId = programId
    }

    return axios
      .post(`${apiURL}/graphql`, { query, variables })
      .then(response => {
        let payload = null
        if (response.data.data.getCourseList) {
          payload = response.data.data.getCourseList.Programs
        }
        dispatch({ type: 'SET_PROGRAMS', payload })
        return response.data.data.getCourseList
      })
      .catch(err => axiosError(err, requestId, dispatch))
  }
}

export default getCourseList
